/**
 * Global /reports page. EvaluationPickerSheet → on pick → ReportWorkspace
 * (the C3/C4 component) inside the shared module-page chrome. URL preserves
 * the picked evaluation via `?eval=<id>` so reload + share-link both work.
 *
 * Linear: MYD-198 (C5).
 */

import EvaluationModulePage from './_EvaluationModulePage'
import ReportWorkspace from '../components/reports/ReportWorkspace'

const ReportsPage = () => (
	<EvaluationModulePage
		moduleName="Reports"
		moduleDescription="Pick an evaluation to generate PDF or DOCX reports from its data."
		workspacePhase="MYD-196 (C3)"
		workspaceHint="Template + format picker, generation queue, history with re-download, and inline preview."
		renderWorkspace={(evalId) => <ReportWorkspace evalId={evalId} />}
	/>
)

export default ReportsPage
